import { get } from "../helpers/apihelpers";

export const GetDashboardService=async()=>{
    try {
        const result = await get(`api/dashboard/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetFilterStandardDashboardService=async()=>{
    try {
        const result = await get(`api/dashboard/get_filter_standard`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetLeaderDashboardService=async()=>{
    try {
        const result = await get(`api/dashboard/get_leaderboard`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetLeaderDashboardTransactionBasedUserService=async(id='',text='',from_date='',to_date='',page=1)=>{
    try {
        const result = await get(`api/user/get_wallet_transaction_based_user_business/${id}?search=${text}&from_date=${from_date}&to_date=${to_date}&page=${page}`);
        return result;
    } catch (err) {
        return err.response;
    }
}
